var map = {
	"./Grafmonument 1.png": 87820,
	"./Grafmonument 2.png": 54855,
	"./Grafmonument 3.png": 79070,
	"./Grafmonument 4.png": 7281,
	"./Grafmonument 5.png": 75240,
	"./Grafmonument 6.png": 37219,
	"./Grafmonument 7.png": 47386,
	"./Grafmonument 8.png": 269,
	"./Grafmonument 9.png": 37028
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17856;